import { Agent } from "model/agent";

/**
 * Member role label per MAX-3707 naming:
 * - Admin (admin)
 * - Lead Owner (Billable) (ownsLeads)
 * - A member with no role assigned is simply "Member" (the old "Agent (Non-billable)" is removed).
 * A billable admin shows both: "Lead Owner (Billable), Admin".
 */
export const getMemberRoleLabel = (agent: Agent): string => {
	const roles: string[] = [];
	if (agent.ownsLeads) {
		roles.push("Lead Owner (Billable)");
	}
	if (agent.admin) {
		roles.push("Admin");
	}
	return roles.length ? roles.join(", ") : "Member";
};
